<button (click)="openSidenav.emit()" class="action-btn" fxHide.gt-sm mat-icon-button matTooltip="Toggle menu">
  <mat-icon>menu</mat-icon>
</button>
